import { useRef } from 'react';
export default function useThrottle(func, delay) {
    const lastCall = useRef(0);
    const timer = useRef();
    return () => {
        const now = Date.now();
        if (now - lastCall.current < delay) {
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                lastCall.current = now;
                func();
            }, delay);
        }
        else {
            lastCall.current = now;
            func();
        }
    };
}
//# sourceMappingURL=UseThrottle.js.map